import { getErrorResponse } from 'legacy/lut/functions'
import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpCancel, HttpHeaders, Rest } from 'core/classes/http'

import { ISPJBPResponse } from './models/ISPJBPResponse'

export const requestJBPActualsAndTargetsSettings = async <T>(
  partnerId: string,
  fromFYear: number,
  programType?: string,
  filters?: string,
  cancelObject?: HttpCancel
): Promise<ISPJBPResponse<T>> => {
  let response

  const url = proxy('/webservice/621/sp/v3/spJBPActualsAndTargetsSettings/call')

  const standartPayload = programType
    ? {
        'p.PartnerId': partnerId,
        'p.FYear': fromFYear,
        'p.ProgramType': programType,
      }
    : {
        'p.PartnerId': partnerId,
        'p.FYear': fromFYear,
      }

  const payload = !filters
    ? standartPayload
    : {
        'p.Filters': filters,
      }

  const { app } = appGetState()
  const [accessToken] = getTokens(app.ownerId)

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    response = await Rest.post({ url, payload, cancelObject, headers })
  } catch (e: any) {
    const errorMessage = `Failed to request Actuals and Targets Settings. Partner: '${partnerId}', FYear: '${fromFYear}', ProgramType: '${programType}'. With filter '${filters}'`
    response = getErrorResponse<ISPJBPResponse<T>>(e.message || errorMessage, {
      Total: 0,
      Rows: [],
    })
  }

  return response
}
